<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-payment-methods-detail [pk]="pk" [mode]="mode" [defaults]="defaults"
                                   (detailSaved)="modal.close($event)"
                                   (detailCancelled)="modal.dismiss()">
    </app-payment-methods-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-payment-methods-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                                  [disabledButtons]="localDisabledButtons" [disabledColumns]="disabledColumns"
                                  [filters]="filters" [disableRouterLink]="true">
    </app-payment-methods-list>
  </ng-template>
</div>